<template>
    <div class="wrapper d-none d-md-block">
        <div>
            <v-row>
                <v-col>
                    <div style="text-align: center">
                        <b-button
                            variant="outline-primary"
                            v-on:click="toggleShow"
                            >Rozvádzače
                            <font-awesome-icon
                                :icon="['fas', hidden ? 'eye' : 'eye-slash']"
                                size="sm"
                            />
                        </b-button>
                    </div>

                    <v-treeview
                        :items="items"
                        @input="onChange"
                        selectable
                        dense
                        :hidden="hidden"
                        v-model="selected"
                    />
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import api from "../../store/api";
import { bus } from "../../main";

export default {
    name: "Switchboards",
    data() {
        return {
            selected: [],
            items: [],
            hidden: false
        };
    },
    mounted() {
        this.loadSwitchBoard();
        bus.$on("resetSwitchboard", this.reset);
        this.hidden = localStorage.showSwitchgear;
    },
    methods: {
        loadSwitchBoard: function() {
            api.get(`/markers/switchboards`).then(response => {
                this.items = response.data;
            });
        },
        onChange: function(items) {
            this.$emit("input", items);
        },
        reset: function() {
            this.selected = [];
        },
        toggleShow: function() {
            this.hidden = !this.hidden;
            localStorage.showSwitchgear = this.hidden;
        }
    }
};
</script>

<style scoped>
.wrapper {
    position: absolute;
    top: 0px;
    left: 0;
    width: 180px;
    z-index: 99999;
    max-height: calc(100vh - 80px);
    overflow-y: scroll;
    overflow-x: hidden;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
    border-radius: 2px;
}
</style>

<style lang="scss">
.v-treeview-node__label {
    font-size: 12px !important;
    padding-top: 7px;
    font-family: "Avenir", Helvetica, Arial, sans-serif;
}
.v-treeview-node__root {
    min-height: 25px !important;
    svg {
        width: 20px !important;
    }
    .v-treeview-node__toggle {
        svg {
            transform: rotate(-90deg);
        }
    }
    .v-treeview-node__toggle--open {
        svg {
            transform: rotate(0deg);
        }
    }
}
.v-application--is-ltr {
    .v-treeview-node__toggle {
        transform: rotate(-90deg);
    }
}
</style>
